export function copyObject(obj) {
  if (typeof obj === 'object') {
    return JSON.parse(JSON.stringify(obj))
  } else return obj
}

export function copyObjectBy(srcKeyObj, fromObj) {
  if (!fromObj) return null

  const _src = srcKeyObj ?? fromObj

  if (typeof fromObj === 'object') {
    if (Array.isArray(_src)) {
      // если массив берём как образец первый элемент
      const data = []
      for (let key in fromObj) {
        const value = fromObj[key]

        if (typeof value === 'object') {
          data[key] = copyObjectBy(_src[0], value)
        } else data[key] = value
      }
      return data
    } else {
      // если объект
      const data = {}
      for (let key in _src) {
        const value = fromObj[key]

        if (typeof value === 'object') {
          data[key] = copyObjectBy(_src[key], value)
        } else data[key] = value
      }
      return data
    }
  } else return null
}

/** Сравниваем два объекта в лоб через stringify */
export function sameObject(obj1, obj2) {
  if (typeof obj1 === 'object' && typeof obj2 === 'object')
    return JSON.stringify(obj1) === JSON.stringify(obj2)
  return obj1 === obj2
}

/** If the path is a string, convert it to an array
 * @param  {String|Array} path The path
 * @return {Array}             The path array
 */
export function stringToPath(path) {
  if (!path) return []
  // If the path isn't a string, return it
  if (typeof path !== 'string') return path
  const output = []
  // Split to an array with dot notation
  path.split('.').forEach(item => {
    // Split to an array with bracket notation
    item.split(/\[([^}]+)\]/g).forEach(key => {
      // Push to the new array
      if (key?.length) output.push(key)
    })
  })
  return output
}

/** Get an object value from a specific path
 * (c) 2018 Chris Ferdinandi, MIT License, https://gomakethings.com
 * @param  {Object}       obj  The object
 * @param  {String|Array} path The path
 * @param  {*}            def  A default value to return [optional]
 * @return {*}                 The value
 */
export function objectByPath(obj, path, def) {
  if (!path || !obj) return obj
  // Get the path as an array
  path = stringToPath(path)
  // Cache the current object
  var current = obj
  // For each item in the path, dig into the object
  for (var i = 0; i < path.length; i++) {
    // If the item isn't found, return the default (or null)
    if (!current[path[i]]) return def
    // Otherwise, update the current  value
    current = current[path[i]]
  }
  return current
}
/** нумеруем элементы (сквозная или по группе)  */
export function setIndexBy(arr, groupBy = '', indexName = 'index') {
  if (!Array.isArray(arr)) return arr
  if (groupBy) {
    const gb = new Map()
    return arr.map(el => {
      const i = (gb.get(el[groupBy]) ?? 0) + 1
      gb.set(el[groupBy], i)
      return { ...el, [indexName]: i }
    })
  } else {
    return arr.map((el, i) => ({ ...el, [indexName]: i + 1 }))
  }
}
